
const initialState = [
    {
        id:0,
        author:'Arthur Schopenhauer',
        authorImg:'https://upload.wikimedia.org/wikipedia/commons/thumb/8/8a/Schopenhauer.jpg/220px-Schopenhauer.jpg',
        category:'Non-Fiction',
        title:'The Two Fundamental Problems of Ethics',
        imageUrl:'https://books.google.com.bd/books/content?id=sTWmVHA_vPAC&pg=PP1&img=1&zoom=3&hl=en&sig=ACfU3U0lDlQUPCTE2CLtmsGvlxS61pgpcg&w=1280',
        dateAdded:'21-08-2022',
        duration:'120 min read'
    },
    {
        id:1,
        author:'Aldous Huxley',
        authorImg:'https://images2.minutemediacdn.com/image/upload/c_fill,w_1080,ar_16:9,f_auto,q_auto,g_auto/shape%2Fcover%2Fsport%2Fgettyimages-2665140-a1c77ccabe8660fb5123c8b6c5741316.jpg',
        category:'Non-Fiction',
        title:'Heaven and Hell',
        imageUrl:'https://upload.wikimedia.org/wikipedia/en/2/2c/Heaven_and_Hell_%28essay%29_1st_edition_cover.jpg',
        dateAdded:'21-08-2022',
        duration:'120 min read'
    },
    {
        id:2,
        author:'Goerge Orwell',
        authorImg:'https://cdn.britannica.com/68/9768-004-F4E88413/George-Orwell.jpg?s=1500x700&q=85',
        category:'Fiction',
        title:'Animal Farm',
        imageUrl:'https://upload.wikimedia.org/wikipedia/commons/f/fb/Animal_Farm_-_1st_edition.jpg',
        dateAdded:'21-08-2022',
        duration:'120 min read'
    },
    {
        id:3,
        author:'Friedrich Nietzsche',
        authorImg:'https://upload.wikimedia.org/wikipedia/commons/1/1b/Nietzsche187a.jpg',
        category:'Non-Fiction',
        title:'God is dead',
        imageUrl:'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT108zHtV-Y9WRaJ1o6ZjzgCW-2nkfqyZ-sUPDxsydM30lJkY-o',
        dateAdded:'21-08-2022',
        duration:'120 min read'
    },
    {
        id:4,
        author:'Arthur Schopenhauer',
        authorImg:'https://upload.wikimedia.org/wikipedia/commons/thumb/8/8a/Schopenhauer.jpg/220px-Schopenhauer.jpg',
        category:'Non-Fiction',
        title:'The World as Will and Representation',
        imageUrl:'https://images-na.ssl-images-amazon.com/images/I/41bhciW00rL._SY291_BO1,204,203,200_QL40_FMwebp_.jpg',
        dateAdded:'21-08-2022',
        duration:'120 min read'
    },
    {
        id:5,
        author:'Carl Gustav Jung',
        authorImg:'https://upload.wikimedia.org/wikipedia/commons/thumb/5/5b/ETH-BIB-Jung%2C_Carl_Gustav_%281875-1961%29-Portrait-Portr_14163_%28cropped%29.tif/lossy-page1-1024px-ETH-BIB-Jung%2C_Carl_Gustav_%281875-1961%29-Portrait-Portr_14163_%28cropped%29.tif.jpg',
        category:'Non-Fiction',
        title:'The Red Book',
        imageUrl:'https://upload.wikimedia.org/wikipedia/commons/d/d8/The_Red_Book_by_Carl_Jung%2C_2009.jpg',
        dateAdded:'21-08-2022',
        duration:'120 min read'
    },
    {
        id:6,
        author:'Aldous Huxley',
        authorImg:'https://images2.minutemediacdn.com/image/upload/c_fill,w_1080,ar_16:9,f_auto,q_auto,g_auto/shape%2Fcover%2Fsport%2Fgettyimages-2665140-a1c77ccabe8660fb5123c8b6c5741316.jpg',
        category:'Fiction',
        title:'Brave new world',
        imageUrl:'https://images-na.ssl-images-amazon.com/images/I/51qUjJFVSpL._SY291_BO1,204,203,200_QL40_FMwebp_.jpg',
        dateAdded:'21-08-2022',
        duration:'150 min read'
    },
    {
        id:7,
        author:'Goerge Orwell',
        authorImg:'https://cdn.britannica.com/68/9768-004-F4E88413/George-Orwell.jpg?s=1500x700&q=85',
        category:'Fiction',
        title:'1984',
        imageUrl:'https://www.storytel.com/images/640x640/0002933941.jpg',
        dateAdded:'21-08-2022',
        duration:'120 min read'
    },
];

const blogReducer = (state = initialState, action) => {
    return state;
};

export default blogReducer;
